<template>
  <v-container class="container-layout py-1">
    <template>
      
      <div>
        <div>
          <v-row dense>
            <v-col cols="12">
              <h3 class="text-center" style="color: #000;">
                ＪＷＮＥＴ‐ＥＤＩ連携サービス利用申込書
              </h3>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <div class="block">
                DXE株式会社　宛
              </div>
            </v-col>
          </v-row>

          <!-- 排出事業者／排出事業場 -->
          <v-row dense>
            <v-col cols="12">
              <div class="table" style="width: 100%; border:none;" >

                <div class="table_line" style="height:12mm">
                  <div class="block bordered_b_s" style="width: 50%;font-size:90%;text-align:center;vertical-align: middle;">
                    利用規約に同意し、下記のとおり申し込みます。
                  </div>
                  <div class="block label bordered_l_s bordered_r bordered_t_s bordered_b" style="width: 10%;">
                    申込日
                  </div>
                  <div class="block bordered_r_s bordered_t_s bordered_b" style="width: 40%;text-align:right;vertical-align: middle;">
                    年
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日
                    &nbsp;&nbsp;
                  </div>
                </div>
              </div>

              <div class="table" style="width: 100%;">
                <div class="table_line" style="height:18mm">
                  <div class="block label bordered_l_s bordered_r" style="width: 12%;">
                  </div>
                  <div class="block bordered_b pl-1" style="width: 38%;">
                    名称
                  </div>
                  <div class="block bordered_r_s bordered_b" style="width: 50%;">
                  </div>
                </div>

                <div class="table_line" style="height:22mm">
                  <div class="block label bordered_l_s bordered_r" style="width: 12%;">
                    ご契約者
                  </div>
                  <div class="block bordered_r_s bordered_b pl-1" style="width: 88%;">
                    住所&nbsp;&nbsp;&nbsp;&nbsp;〒&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ー
                  </div>
                </div>

                <div class="table_line" style="height:16.5mm">
                  <div class="block label bordered_l_s bordered_r bordered_b" style="width: 12%;">
                  </div>
                  <div class="block bordered_r_s bordered_b pl-1" style="width: 88%;">
                    TEL
                  </div>
                </div>

                <div class="table_line" style="height:15.5mm">
                  <div class="block label px-1 bordered_l_s bordered_r bordered_b" style="width: 24%;text-align:left; font-weight: bold;">
                    加入者番号
                  </div>
                  <div class="block bordered_r_s bordered_b" style="width: 76%;">
                  </div>
                </div>

                <div class="table_line" style="height:15.5mm">
                  <div class="block label px-1 bordered_l_s bordered_r bordered_b_s" style="width: 24%;text-align:left; font-weight: bold;">
                    ＥＤＩ利用確認キー
                  </div>
                  <div class="block bordered_r_s bordered_b_s" style="width: 76%;">
                  </div>
                </div>

              </div>
            </v-col>
          </v-row>
          <!-- /排出事業者／排出事業場 -->

          <!-- サイン欄 -->
          <v-row dense class="">
            <div class="table strong" style="width: 50%;height:38mm; font-size:80%; margin-left: auto; margin-right: 4px;">
              <div class="block pl-2 pt-1" style="line-height: 25px">
              利用規約に同意し、上記の内容で申し込みます。<br>
              お客様ご確認欄<span style="font-size:70%;">（ご記入頂いた方のフルネームサインをお願い致します）</span>
              </div>
            </div>
          </v-row>
          <!-- /サイン欄 -->

          <!-- ここにEDI利用確認キーの確認方法のイメージを貼り付け -->
          <v-row dense>
            <v-col cols="12">
              <div class="block">
                ●EDI利用確認キーの確認方法
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="table_line">
                <div class="block" style="width: 100%;">
                  <img
                    height="367px"
                    width="418px"
                    :src="require(`@/assets/images/jwnet_edi_usage_key.png`)"
                  />
                  <!-- :src="public_path('/assets/images/jwnet_edi_usage_key.png')" -->
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- フッター -->
          <v-row dense>
            <v-col cols="12">
              <div class="table" style="width: 100%;border: none;">
                <div class="table_line" style="font-size:90%;">
                  <div class="block">
                    DXE株式会社記入欄
                  </div>
                </div>
              </div>

              <div class="table" style="width: 75%; border: 1px solid #000">
                <div class="table_line">
                  <div class="block bordered_r" style="width: 15%;">
                    <span class="pl-1" style="font-size:85%;">処理業者</span>
                  </div>
                  <div class="block" style="width: 60%;">
                    <span class="pl-1" style="font-size:85%;">{{ tenant.subscriber_number }}：{{ tenant.name }}</span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /フッター -->
        </div>
        <hr class="print-break" style="margin-top: 5px;margin-bottom: 5px;" />

        <div class="pt-5">
          <!-- 規約文章 -->
          <v-row dense>
            <v-col cols="12">
              <div class="block" style="font-size:85%;"
                  v-html="tenant.terms_of_edi_request">
              </div>
            </v-col>
          </v-row>
          <!-- /規約文章 -->
          <!-- <hr class="print-break" style="margin-top: 5px;margin-bottom: 5px;" /> -->
        </div>

      </div>
    </template>
  </v-container>

</template>

<script>
export default {
  name: "JwnetEdiApplicationFormTemplate",
  components: {},
  mixins: [],
  props: {
    tenant: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      systemTime: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.systemTime = this.$dayjs().format("YYYY/MM/DD HH:mm")
  },
  updated() {
    /** @typedef document */
    document.title = 'DXE Station EDI Form - type2'
  },
  methods: {}
}
</script>

<style scoped lang="scss">
body {
  overflow-y: scroll;
  height: auto;
}
.container-layout {
  border: solid 1px #ddd;
  background-color: #fff;
  width: 210mm;
}

.table {
  &.strong {
    border: 2.5px solid #000;
  }
}

.table_line {
  display: table;
  width: 100%;
  &.furigana {
    border-bottom: 1px dashed #000;
    height: 4mm;
  }
}

.block {
  display: table-cell;
  vertical-align: initial;
  color: #000;

  &.req {
    background-color: #dddddd;
  }

  &.label {
    text-align: center;
    vertical-align: middle;
    font-size: 90%;
  }

  &.bordered_l_s {
    border-left: solid 3px #000;
  }

  &.bordered_r {
    border-right: solid 1px #000;
  }

  &.bordered_r_s {
    border-right: solid 3px #000;
  }

  &.bordered_t_s {
    border-top: solid 3px #000;
  }

  &.bordered_b {
    border-bottom: solid 1px #000;
  }

  &.bordered_b_s {
    border-bottom: solid 3px #000;
  }

  &.bordered_name_r {
    border-right: dotted 1px #000;
  }

  /* v-html内のスタイル */
  /deep/ p {
    margin-bottom: 0;
    &.ql-align-center {
      text-align: center;
    }
    &.ql-align-right {
      text-align: right;
    }
    &.ql-align-justify {
      text-align: left;
    }
  }

  /deep/ pre {
    background-color: black;
    color: white;
    overflow: visible;
  }

  /deep/ blockquote {
    border-left: 4px solid #CCC;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-left: 16px;
  }

  & span {
    vertical-align: center;
  }

}

hr {
  page-break-after: always;
}
@media print {
  .container-layout {
    border: none;
  }
  .print-break {
    page-break-after: always;
    border: none;
  }
}
</style>
